import { render, staticRenderFns } from "./NewAccountSettingShare.vue?vue&type=template&id=07c0f843&scoped=true&"
import script from "./NewAccountSettingShare.vue?vue&type=script&lang=js&"
export * from "./NewAccountSettingShare.vue?vue&type=script&lang=js&"
import style0 from "./NewAccountSettingShare.vue?vue&type=style&index=0&id=07c0f843&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c0f843",
  null
  
)

export default component.exports